import { ColTypeEnum } from "../enums/schema-builder-types.enum"

export interface SchemaBuilderRoot {
  [key: string]: SchemaBuilderBuilderData
}

export interface SchemaBuilderBuilderData {
    [key: string]: SchemaBuilderDataObject
}

export interface SchemaBuilderDataObject {
    uid: string
    labels: string[]
    tooltip: string
    format: string
    refTypeCode: string
    parentRefType: string
    validations: SchemaBuilderValidations
    tabs: string
    systemField: boolean
    mandatory: boolean
    type: string
    componentType: string
    labelIndex:number
    hidden:boolean
    option: SchemaBuilderOptions
    formGroupData:string
  }

export interface SchemaBuilderValidations {
    systems: string;
    "size-min": string;
    "size-max": string | number;
    pattern: string;
    patternErrorMsg:string;
  }

export interface SchemaBuilderOptions {
    data: any
    key: string
    label: string
    value: string
    alphaNumeric:boolean
    allowDecimalValue:boolean
    numberValidation:boolean
    format:string
    placeholder:string
    modelOptions:{
      [key: string]: string
    }
    onChange:any
    model:string
    ranges:string
    step:number
    showMsg:string
    optionsData:any[] | SchemaBuilderOptionsData[]
    onSearchEvent:any
    showLoader:string
    click:any
    disabled:boolean
    span:string | number | null
    maxlength:number
    disabledDate:string
    multiple: boolean
  }

export interface SchemaBuilderOptionsData {
    label: string
    value: string
  }

export interface  SchemaBuilderTableData {
    header: any[]
    sortColumnkey: string[];
    actions: SchemaBuilderTableAction[]
    customizedCol?: SchemaBuilderColumnCustomization[]
    checkBox: SchemaBuilderTableCheckBox
    data: any[]
    dataKeys: string[]
    pagination: SchemaBuilderTablePagination
    sort: any;
  }
  export interface SchemaBuilderColumnCustomization {
    key: string;
    colType: ColTypeEnum;
    showHide?: { key: string, value: string, option: string },
    tag?: {css?: string, eventHandler?: any, cssHandler?: any};
    icon?: {css?: string, eventHandler?: any, cssHandler?: any,
       nzType?: string,
       nzTypeHandler?:any;
       nzTheme?: string,
       showWithText?: boolean,
       toolTipKey?: string,
       mutilineToolTip?: boolean;
      };
    innerHTML?: {css?: string, eveventHandlerent?: any, cssHandler?: any, content: string};
    a?: {css?: string, eventHandler?: any, cssHandler?: any};
    multipleIcons?: {
      nzType: string;
      showWithText?: boolean;
      toolTipKey?: string;
      mutilineToolTip?: boolean;
      css?: string;
      eventHandler?: any;
      cssHandler?: any;
    }[];  
  }

export interface SchemaBuilderTableAction {
    actionName: string
    actionLabel: string
    actionType: string
    showConfirmOption?: boolean
    actionEvent:any
    showHide?: any;
  }

export interface SchemaBuilderTableCheckBox {
    checkAll: boolean
    selectAllCheckEvent:any
    selectSingleCheckEvent:any
  }

export interface SchemaBuilderTablePagination {
    pageIndex: number
    pageSize: number
    total: number
    onPageChange:any
  }

